<template>
    <div>
        <report-header
            :title="title"
            :isLoading="isLoading"
            :reportPagination="pagination"
            :isShowDateRange="true"
            :formatDateRangeTitle="dateRange"
        />

        <b-card id="report-card">
            <div id="report-body" class="w-100">
                <div class="header pt-3">
                    <div class="col-6 p-0">
                        <p class="m-0">
                            Summary
                        </p>
                    </div>

                    <div class="col-6 p-0 search-option" v-if="!isLoading">
                        <input
                            v-model="filterItem"
                            class="form-control col-md-6"
                            name="title"
                            placeholder="Search by item"
                        />
                        <i
                            class="fas fa-times"
                            v-if="filterItem"
                            @click="filterItem = ''"
                        ></i>
                    </div>
                </div>

                <QTable
                    class="sticky-table"
                    :data="results"
                    :columns="formattedColumnSummary"
                    :pagination="{ sortBy: 'itemName' }"
                    :rows-per-page-options="[0]"
                    row-key="itemId"
                    :filter="filterItem"
                    hide-bottom
                    :table-class="isLoading ? 'overflow-hidden' : ''"
                    virtual-scroll
                    :filter-method="filteringResults"
                >
                    <template v-slot:header="props">
                        <q-tr :props="props">
                            <q-th
                                v-for="col in props.cols"
                                :key="col.name"
                                :props="props"
                                class="sticky-header"
                            >
                                <div
                                    v-if="col.field == 'itemName'"
                                    class="d-flex align-items-center"
                                >
                                    <div
                                        @click="toggleExpandAll()"
                                        class="pr-2"
                                    >
                                        <i
                                            class="cursor-pointer m-auto"
                                            :class="
                                                checkExpandIcon(isExpandAll)
                                            "
                                        ></i>
                                    </div>
                                    <div>
                                        <strong
                                            @click="toggleExpandAll()"
                                            class="cursor-pointer"
                                        >
                                            {{ col.label }}
                                        </strong>
                                    </div>
                                </div>
                                <strong v-else>{{ col.label }}</strong>
                            </q-th>
                        </q-tr>
                        <q-tr :props="props" v-if="isHasExpand">
                            <th
                                colspan="12"
                                class="sticky-header-inner py-0 pl-0 pr-1"
                            >
                                <table class="table table-hover m-0">
                                    <thead>
                                        <tr class="table-borderless">
                                            <th
                                                class="sticky-header-close column-close cursor-pointer"
                                                @click="
                                                    () => {
                                                        innerHeaderClosed = true;
                                                    }
                                                "
                                            >
                                                <i class="fas fa-times"></i>
                                            </th>
                                            <th
                                                v-for="header in innerHeaders"
                                                :key="header.name"
                                                :style="header.styles"
                                                class="align-middle"
                                            >
                                                {{ header.name }}:
                                            </th>
                                        </tr>
                                    </thead>
                                </table>
                            </th>
                        </q-tr>
                        <q-linear-progress
                            v-show="isLoading"
                            class="sticky-loader"
                            indeterminate
                            color="dark"
                            :style="isHasExpand ? 'top:96px' : 'top:48px'"
                        />
                    </template>
                    <template v-slot:body="props">
                        <q-tr :props="props" :key="`m_${props.key}`">
                            <q-td
                                v-for="col in props.cols"
                                :key="col.name"
                                :props="props"
                            >
                                <div
                                    v-if="col.name == 'itemName'"
                                    class="d-flex align-items-center"
                                >
                                    <span
                                        @click="toggleExpandItem(props)"
                                        class="pr-2"
                                    >
                                        <i
                                            class="cursor-pointer"
                                            :class="
                                                checkExpandIcon(
                                                    props.row.expand
                                                )
                                            "
                                        ></i>
                                    </span>
                                    <div
                                        @click="toggleExpandItem(props)"
                                        class="text-link"
                                    >
                                        {{ col.value }}
                                    </div>
                                </div>
                                <div v-else>
                                    {{ col.value }}
                                </div>
                            </q-td>
                        </q-tr>
                        <q-tr
                            v-if="props.row.expand"
                            :props="props"
                            class="color-grey q-virtual-scroll--with-prev"
                            :key="`e_${props.key}`"
                            no-hover
                        >
                            <q-td
                                colspan="100%"
                                class="border-left py-4 pl-0 pr-1 color-grey"
                            >
                                <div class="table-responsive mb-0">
                                    <table
                                        class="table table-hover table-inner"
                                    >
                                        <thead>
                                            <tr class="table-borderless">
                                                <th
                                                    class="column-close table-inner-header-close"
                                                ></th>
                                                <th
                                                    v-for="header in innerHeaders"
                                                    :key="header.name"
                                                    :style="header.styles"
                                                >
                                                    {{ header.name }}:
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                v-for="invoice in invoices[
                                                    props.row.itemId
                                                ]"
                                                :key="invoice.rowKey"
                                            >
                                                <td class="border-0"></td>
                                                <td
                                                    :class="
                                                        isBold(invoice.date)
                                                    "
                                                    class="text-left"
                                                >
                                                    {{ invoice.date }}
                                                </td>
                                                <td class="text-left">
                                                    <a
                                                        v-if="
                                                            invoice.invoice_encoded_id
                                                        "
                                                        :href="
                                                            env.APPS +
                                                                'billing/invoice/view/' +
                                                                invoice.invoice_encoded_id ||
                                                            '#'
                                                        "
                                                        target="_blank"
                                                    >
                                                        {{
                                                            invoice.invoiceIndex
                                                        }}
                                                    </a>
                                                    <span v-else>
                                                        {{
                                                            invoice.invoiceIndex
                                                        }}
                                                    </span>
                                                </td>

                                                <td
                                                    class="text-left text-capitalize"
                                                >
                                                    <b-link
                                                        v-if="
                                                            invoice.client_encoded_id &&
                                                            invoice.client_name &&
                                                            invoice.client_active ==
                                                                1
                                                        "
                                                        :to="{
                                                            name:
                                                                'client_profile',
                                                            params: {
                                                                id:
                                                                    invoice.client_encoded_id
                                                            }
                                                        }"
                                                        >{{
                                                            invoice.client_name
                                                        }}</b-link
                                                    >

                                                    <span v-else>
                                                        {{
                                                            invoice.client_name
                                                        }}
                                                        <span
                                                            class="text-lowercase"
                                                            v-if="
                                                                invoice.client_active ==
                                                                0
                                                            "
                                                            >(deleted)</span
                                                        >
                                                    </span>
                                                </td>
                                                <td
                                                    class="text-left text-capitalize"
                                                >
                                                    <router-link
                                                        v-if="
                                                            invoice.patient_encoded_id
                                                        "
                                                        :to="{
                                                            name:
                                                                'patient_profile',
                                                            params: {
                                                                id:
                                                                    invoice.patient_encoded_id
                                                            }
                                                        }"
                                                    >
                                                        {{
                                                            invoice.patient_name
                                                        }}
                                                    </router-link>
                                                    <span v-else>
                                                        {{
                                                            invoice.patient_name
                                                        }}
                                                    </span>
                                                </td>
                                                <td
                                                    class="text-left text-capitalize"
                                                >
                                                    {{ invoice.provider_name }}
                                                </td>
                                                <td
                                                    class="text-left"
                                                    :class="
                                                        isBold(invoice.date)
                                                    "
                                                >
                                                    {{ invoice.quantity }}
                                                </td>
                                                <td
                                                    class="text-left"
                                                    :class="
                                                        isBold(invoice.date)
                                                    "
                                                >
                                                    {{ invoice.amountCurrency }}
                                                </td>
                                                <td
                                                    class="text-left"
                                                    :class="
                                                        isBold(invoice.date)
                                                    "
                                                >
                                                    {{ invoice.taxCurrency }}
                                                </td>
                                                <td
                                                    class="text-left"
                                                    :class="
                                                        isBold(invoice.date)
                                                    "
                                                >
                                                    {{
                                                        invoice.grossSalesCurrency
                                                    }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </q-td>
                        </q-tr>
                    </template>
                    <template v-slot:bottom-row>
                        <q-tr
                            v-if="results.length == 0 && !isLoading && !isError"
                        >
                            <q-td colspan="12">No records available</q-td>
                        </q-tr>
                        <q-tr v-else-if="results.length > 0 && !isError">
                            <q-td class="text-bold">Grand Total</q-td>
                            <q-td class="text-bold">
                                <loader v-if="isLoading" />
                                <span v-else>{{
                                    filteredGrandTotalInvoices
                                }}</span>
                            </q-td>
                            <q-td class="text-bold">
                                <loader v-if="isLoading" />
                                <span v-else>
                                    {{ filteredGrandTotalClients }}</span
                                >
                            </q-td>
                            <q-td class="text-bold">
                                <loader v-if="isLoading" />
                                <span v-else>
                                    {{ filteredGrandTotalPatients }}</span
                                >
                            </q-td>
                            <q-td class="text-bold">
                                <loader v-if="isLoading" />
                                <span v-else>
                                    {{ filteredGrandTotalQuantity.toFixed(3) }}
                                </span>
                            </q-td>
                            <q-td class="text-bold">
                                <loader v-if="isLoading" />
                                <span v-else>
                                    {{ _toCurrency(filteredGrandTotalAmount) }}
                                </span>
                            </q-td>
                            <q-td class="text-bold">
                                <loader v-if="isLoading" />
                                <span v-else>{{
                                    _toCurrency(filteredGrandTotalTax)
                                }}</span>
                            </q-td>
                            <q-td class="text-bold">
                                <loader v-if="isLoading" />
                                <span v-else>{{
                                    _toCurrency(filteredGrandTotalGrossSales)
                                }}</span>
                            </q-td>
                        </q-tr>
                    </template>
                </QTable>
            </div>
        </b-card>
    </div>
</template>
<script>
import Report from "@/mixins/report.js";
import CREPORT from "@/constants/report";
import { some } from "lodash";
import { QTable } from "quasar";
import "@/css/quasar-table.css";
import Loader from "@/components/elements/loader-custom";
import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;
const ICON_COLLAPSE = "fas fa-chevron-circle-right";
const ICON_EXPAND = "fas fa-chevron-circle-down";
export default {
    components: {
        QTable,
        Loader,
        ReportHeader: () => import("@/components/report/report-header")
    },
    mixins: [Report],
    props: {
        data: {
            type: Object
        }
    },
    data() {
        return {
            filterItem: "",
            dateRange: "",
            isLoading: true,
            isError: false,
            isExpandAll: false,
            results: [],
            invoices: [],
            title: "Sales By Item",
            grandTotalInvoices: 0,
            grandTotalClients: 0,
            grandTotalPatients: 0,
            grandTotalQuantity: 0,
            grandTotalAmount: 0,
            grandTotalTax: 0,
            grandTotalGrossSales: 0,
            filteredGrandTotalInvoices: 0,
            filteredGrandTotalClients: 0,
            filteredGrandTotalPatients: 0,
            filteredGrandTotalQuantity: 0,
            filteredGrandTotalAmount: 0,
            filteredGrandTotalTax: 0,
            isDestroyed: false,
            indexAxios: 0,
            abortController: [],
            innerHeaderClosed: false,
            formattedColumnSummary: [
                {
                    name: "itemName",
                    label: "Item",
                    field: "itemName",
                    align: "left",
                    style: "min-width: 192px"
                },
                {
                    name: "itemTotalInvoices",
                    label: "Invoices",
                    field: "itemTotalInvoices",
                    align: "left",
                    style: "width: 5%"
                },
                {
                    name: "itemTotalClient",
                    label: "Clients",
                    field: "itemTotalClient",
                    align: "left",
                    style: "width: 5%"
                },
                {
                    name: "itemTotalPatient",
                    label: "Patients",
                    field: "itemTotalPatient",
                    align: "left",
                    style: "width: 5%"
                },
                {
                    name: "itemTotalQuantity",
                    label: "Qty",
                    field: "itemTotalQuantity",
                    format: (val, row) => {
                        // the quantity already converted into 3 decimal from calculation in renderSummaryData
                        return row.itemTotalQuantity.toFixed(3) + " " + row.uom;
                    },
                    align: "left",
                    style: "width: 10%"
                },
                {
                    name: "itemTotalAmounts",
                    label: "Amount",
                    field: "itemTotalAmounts",
                    align: "left",
                    format: (val, row) => {
                        return this._toCurrency(row.itemTotalAmounts);
                    },
                    style: "width: 8%"
                },
                {
                    name: "itemTotalTax",
                    label: "Tax",
                    field: "itemTotalTax",
                    align: "left",
                    format: (val, row) => {
                        return this._toCurrency(row.itemTotalTax);
                    },
                    style: "width: 8%"
                },
                {
                    name: "itemTotalGrossSales",
                    label: "Gross Sales",
                    field: "itemTotalGrossSales",
                    align: "left",
                    format: (val, row) => {
                        return this._toCurrency(row.itemTotalGrossSales);
                    },
                    style: "width: 8%"
                },
                {
                    name: "latestCost",
                    label: "Latest Cost",
                    field: "latestCost",
                    align: "left",
                    format: (val, row) => {
                        return this._toCurrency(row.latestCost);
                    },
                    style: "width: 8%"
                },
                {
                    name: "averageCost",
                    label: "Average Cost",
                    field: "averageCost",
                    align: "left",
                    format: (val, row) => {
                        return this._toCurrency(row.averageCost);
                    },
                    style: "width: 5%"
                },
                {
                    name: "highestPrice",
                    label: "Highest Cost",
                    field: "highestPrice",
                    align: "left",
                    format: (val, row) => {
                        return this._toCurrency(row.highestPrice);
                    },
                    style: "width: 5%"
                },
                {
                    name: "lowestPrice",
                    label: "Lowest Cost",
                    field: "lowestPrice",
                    align: "left",
                    format: (val, row) => {
                        return this._toCurrency(row.lowestPrice);
                    },
                    style: "width: 5%"
                }
            ],
            innerHeaders: [
                { name: "Date", styles: "width: 150px;" },
                { name: "Invoice", styles: "width: 150px;" },
                { name: "Client", styles: "width: 160px;" },
                { name: "Patient", styles: "width: 160px;" },
                { name: "Provider", styles: "width: 150px;" },
                { name: "Quantity", styles: "width: 140px;" },
                { name: "Amount", styles: "width: 120px;" },
                { name: "Tax", styles: "width: 120px;" },
                { name: "Gross Sales", styles: "width: 120px;" }
            ]
        };
    },
    computed: {
        isHasExpand() {
            return (
                some(this.results, { expand: true }) && !this.innerHeaderClosed
            );
        }
    },
    async mounted() {
        let self = this;
        self.toggleOptions(false);
        self.data.isShowItemClass = true;
        self.data.isShowDateRange = true;
        self.data.isShowItemOptions = true;
        self.data.filterTitle = "Filter Report";
        self.data.reportId = CREPORT.TYPE.SALES_BY_ITEM;
        self.data.datePickerOptionDefault = 1;
        self.data.itemClass = 0;
        self.dynamicPageTitle(self.title);
        await self._getSetting();
        self.data.start = self.getStartDate("day");
        self.data.end = self.getEndDate("day");
        self.data.from = self.converToUnix(self.data.start);
        self.data.to = self.converToUnix(self.data.end);

        self.init({}, self.indexAxios);

        self.$root.$on("report-filter-date-range:refresh", this.prepareData);
    },
    beforeDestroy: function () {
        this.isDestroyed = true;
        this.data.itemType = null;
        this.data.datePickerOptionDefault = null;
        this.data.reportId = null;
        this.data.isShowItemOptions = false;
        this.data.filterTitle = "Filter Date";
        this.data.items = [];
        this.data.itemShowMode = 1;
        this.$root.$off("report-filter-date-range:refresh", this.prepareData);
    },
    watch: {
        filterItem(value) {
            // when remove filter items completely (''), qtable filter-method not triggered
            if (value == "") {
                this.resetFilteredGrandTotals();
            }
        }
    },
    methods: {
        prepareData(params) {
            this.resetGrandTotal();

            this.results = [];
            this.isLoading = true;
            this.isExpandAll = false;
            this.resetPagination();

            this.filterItem = "";
            this.toggleOptions(false);

            if (params) {
                this.data.itemClass = params.itemClass;
                this.data.from = params.from;
                this.data.to = params.to;
                this.data.items = params.items;
                this.data.itemShowMode = params.itemShowMode;
            }

            if (this.abortController.length > 0) {
                this.abortController[this.indexAxios].abort();
            }
            this.indexAxios++;
            this.init(params, this.indexAxios);
        },
        resetGrandTotal() {
            this.grandTotalInvoices = 0;
            this.grandTotalClients = 0;
            this.grandTotalPatients = 0;
            this.grandTotalQuantity = 0;
            this.grandTotalAmount = 0;
            this.grandTotalTax = 0;
            this.grandTotalGrossSales = 0;
            this.resetFilteredGrandTotals();
        },
        filteringResults(rows) {
            let self = this;
            self.filteredGrandTotalInvoices = 0;
            self.filteredGrandTotalClients = 0;
            self.filteredGrandTotalPatients = 0;
            self.filteredGrandTotalQuantity = 0;
            self.filteredGrandTotalAmount = 0;
            self.filteredGrandTotalTax = 0;
            self.filteredGrandTotalGrossSales = 0;

            return rows.filter(row => {
                let isFiltered = row.itemName
                    .toLowerCase()
                    .includes(self.filterItem.toLowerCase());

                if (isFiltered) {
                    self.filteredGrandTotalInvoices += row.itemTotalInvoices;
                    self.filteredGrandTotalClients += row.itemTotalClient;
                    self.filteredGrandTotalPatients += row.itemTotalPatient;
                    self.filteredGrandTotalQuantity += row.itemTotalQuantity;
                    self.filteredGrandTotalAmount += row.itemTotalAmounts;
                    self.filteredGrandTotalTax += row.itemTotalTax;
                    self.filteredGrandTotalGrossSales +=
                        row.itemTotalGrossSales;
                }
                return isFiltered;
            });
        },
        resetFilteredGrandTotals() {
            this.filteredGrandTotalInvoices = this.grandTotalInvoices;
            this.filteredGrandTotalClients = this.grandTotalClients;
            this.filteredGrandTotalPatients = this.grandTotalPatients;
            this.filteredGrandTotalQuantity = this.grandTotalQuantity;
            this.filteredGrandTotalAmount = this.grandTotalAmount;
            this.filteredGrandTotalTax = this.grandTotalTax;
            this.filteredGrandTotalGrossSales = this.grandTotalGrossSales;
        },
        toggleOptions(value) {
            // to hide the action menu when data is loading
            this.data.exportOption = value;
            this.data.refreshOption = value;
        },
        async init(params, indexAxios) {
            let self = this;
            self.abortController[indexAxios] = new AbortController();
            params = {
                page: self.pagination.page,
                perPage: self.RECORD_PER_PAGE,
                itemClass: params ? params.itemClass : self.data.itemClass,
                from: self.data.from,
                to: self.data.to,
                items: self.data.items
                    ? self.data.items.map(item => {
                          return item.raw_id_with_type;
                      })
                    : []
            };
            self.dateRange = self.getDateRange(self.data.from, self.data.to);

            await self
                .fetchRecords(params, indexAxios)
                .then(res => {
                    if (res.message.code === 200) {
                        let resource = res.resource;

                        self.renderSummaryData(resource.results.item_list);
                        self.pagination.lastPage = Math.ceil(
                            resource.meta.item_count / self.RECORD_PER_PAGE
                        );
                        self.continueFetch(params, indexAxios);

                        self.title = resource.meta.title;
                        self.dynamicPageTitle(self.title);
                        self.dateRange = self.getDateRange(
                            resource.meta.from,
                            resource.meta.to
                        );
                    } else {
                        throw new Error("Error: Unable to get the report.");
                    }
                })
                .catch(e => {
                    if (!self.abortController[indexAxios].signal.aborted) {
                        console.error(e);
                        self.isError = true;
                        self._message(
                            "Error: Unable to get the report",
                            "danger"
                        );
                        self.isLoading = false;
                        self.loadingCompleted();
                    }
                });
        },
        async continueFetch(params, indexAxios) {
            let self = this;
            while (
                self.pagination.page < self.pagination.lastPage &&
                !self.isDestroyed &&
                !self.isError &&
                self.abortController.length > 0 &&
                !self.abortController[indexAxios].signal.aborted
            ) {
                self.pagination.page += 1;
                params.page = self.pagination.page;
                await self.timer(self.INTERVAL_TIME);

                await self
                    .fetchRecords(params, indexAxios)
                    .then(res => {
                        if (
                            Object.keys(res).length > 0 &&
                            res.message.code === 200
                        ) {
                            self.renderSummaryData(
                                res.resource.results.item_list
                            );
                        } else {
                            throw new Error(
                                "Error: Unable to continue get the report"
                            );
                        }
                    })
                    .catch(e => {
                        if (!self.abortController[indexAxios].signal.aborted) {
                            console.error(e);
                            self.isError = true;
                            self._message(
                                "Error: Unable to continue get the report",
                                "danger"
                            );
                            self.isLoading = false;
                            self.loadingCompleted();
                            self.results = [];
                        }
                    });
            }
            if (!self.abortController[indexAxios].signal.aborted) {
                self.loadingCompleted();
                setTimeout(() => {
                    self.toggleOptions(true);
                    self.isLoading = false;
                }, 1000);
            }
        },
        async fetchRecords(params, indexAxios) {
            this.loadingPercentages();
            return Axios.get(
                `${baseURL}report/reports/${CREPORT.TYPE.SALES_BY_ITEM}`,
                {
                    signal: this.abortController[indexAxios].signal,
                    params
                }
            ).then(response => (response ? response.data.response : []));
        },
        renderSummaryData(results) {
            for (let [itemId, itemInvoices] of Object.entries(results)) {
                let clients = [];
                let patients = [];
                let invoices = [];
                let itemTotalQuantity = 0;
                let itemTotalAmounts = 0;
                let itemTotalTax = 0;
                let itemTotalGrossSales = 0;
                let totalPrice = 0;
                let highestPrice = 0;
                let lowestPrice = 0;

                for (let index = 0; index < itemInvoices.length; index++) {
                    const invoice = itemInvoices[index];
                    if (!invoices.includes(invoice.index)) {
                        invoices.push(invoice.index);
                    }

                    if (!clients.includes(invoice.client_id)) {
                        clients.push(invoice.client_id);
                    }

                    if (!patients.includes(invoice.patient_id)) {
                        patients.push(invoice.patient_id);
                    }

                    itemTotalQuantity = itemTotalQuantity + invoice.qty;
                    itemTotalAmounts = itemTotalAmounts + invoice["Amount"];
                    itemTotalTax = itemTotalTax + invoice["Tax"];
                    itemTotalGrossSales =
                        itemTotalGrossSales + invoice["Gross Sales"];
                    totalPrice = totalPrice + invoice.unit_price;
                    highestPrice =
                        invoice.unit_price > highestPrice
                            ? invoice.unit_price
                            : highestPrice;
                    lowestPrice =
                        invoice.unit_price <= lowestPrice || lowestPrice == 0
                            ? invoice.unit_price
                            : lowestPrice;

                    // ALTER DATA FOR DISPLAY
                    invoice.rowKey = itemId + "-" + index + 1;
                    invoice.invoiceIndex = "Invoice #" + invoice.index;
                    invoice.date =
                        invoice.date == "Total"
                            ? invoice.date
                            : this._toDateTime(invoice.date).toFormat(
                                  this._getLuxonFormat()
                              );
                    invoice.quantity =
                        invoice.qty.toFixed(3) + " " + invoice.uom;
                    invoice.amountCurrency = this._toCurrency(
                        invoice["Amount"]
                    );
                    invoice.taxCurrency = this._toCurrency(invoice["Tax"]);
                    invoice.grossSalesCurrency = this._toCurrency(
                        invoice["Gross Sales"]
                    );
                }

                // Calculate averageCost BEFORE pushing the "Total" row
                const realInvoices = itemInvoices.filter(
                    inv => inv.rowKey !== "total"
                );
                const averageCost = realInvoices.length
                    ? totalPrice / realInvoices.length
                    : 0;

                // FOR LAST ROW SHOWING TOTAL
                itemInvoices.push({
                    date: "Total",
                    rowKey: "total",
                    quantity:
                        itemTotalQuantity.toFixed(3) +
                        " " +
                        itemInvoices[0].uom,
                    amountCurrency: this._toCurrency(itemTotalAmounts),
                    taxCurrency: this._toCurrency(itemTotalTax),
                    grossSalesCurrency: this._toCurrency(itemTotalGrossSales)
                });

                let itemTotalInvoices = invoices.length;
                let itemTotalClient = clients.length;
                let itemTotalPatient = patients.length;

                this.results.push({
                    itemId: itemId,
                    itemName: itemInvoices[0].name,
                    itemTotalInvoices: itemTotalInvoices,
                    itemTotalClient: itemTotalClient,
                    itemTotalPatient: itemTotalPatient,
                    itemTotalQuantity: itemTotalQuantity,
                    uom: itemInvoices[0].uom,
                    itemTotalAmounts: itemTotalAmounts,
                    itemTotalTax: itemTotalTax,
                    itemTotalGrossSales: itemTotalGrossSales,
                    latestCost: itemInvoices[0].unit_price,
                    averageCost,
                    highestPrice: highestPrice,
                    lowestPrice: lowestPrice,
                    expand: false
                });

                this.invoices[itemId] = itemInvoices;

                this.grandTotalInvoices += itemTotalInvoices;
                this.grandTotalClients += itemTotalClient;
                this.grandTotalPatients += itemTotalPatient;
                this.grandTotalQuantity += itemTotalQuantity;
                this.grandTotalAmount += itemTotalAmounts;
                this.grandTotalTax += itemTotalTax;
                this.grandTotalGrossSales += itemTotalGrossSales;
            }

            this.resetFilteredGrandTotals();
        },

        showingGrandTotal(value) {
            if (this.isLoading) {
                return "calculating...";
            } else {
                return value;
            }
        },
        toggleExpandItem(props) {
            props.row.expand = !props.row.expand;

            if (props.row.expand) {
                this.innerHeaderClosed = false;
            }
            // check if all data expand same value, change this.isExpandAll to be same value
            if (!some(this.results, { expand: !props.row.expand })) {
                this.isExpandAll = props.row.expand;
            }
        },
        toggleExpandAll() {
            let self = this;
            self.isExpandAll = !self.isExpandAll;
            self.innerHeaderClosed = !self.isExpandAll;
            self.results = self.results.map(result => {
                result.expand = self.isExpandAll;
                return result;
            });
        },
        checkExpandIcon(isExpand) {
            return isExpand ? ICON_EXPAND : ICON_COLLAPSE;
        },
        isBold(date) {
            return date == "Total" ? "font-weight-bold" : "";
        }
    }
};
</script>
<style>
.color-grey {
    background: #f2f2f2;
}
</style>
